<template>
	<div id="coming-soon-screen">
		<div class="container">
			<div class="content-wrapper">
				<h1 class="main-title title bold" v-html="$t('comingSoonScreen.mainTitle')"></h1>
				<p class="description" v-html="$t('comingSoonScreen.description')"></p>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'ComingSoonScreen',
	components: {},
	data() {
		return {};
	},
	created() {},
	computed: {},
	methods: {},
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/global.scss';

#coming-soon-screen {
	height: 100%;
	display: flex;
	align-items: start;
	justify-content: center;
	background-color: $black;
	padding: 155px 20px;

	@media (max-width: $breakpoint-md) {
		padding: 92px 20px;
	}
}

.main-title {
	margin: 0 0 34px;
	color: #E8E8FF;
	text-transform: uppercase;
	text-align: center;
	font-weight: 700;


	@media (max-width: $breakpoint-sm) {
		margin: 0 0 24px;
		text-align: center;
		font-size: 28px;
		line-height: 34px;
	}
}

.description {
	font-family: 'HKNova', sans-serif;
	margin: 0;
	color: #E8E8FF;
	margin: 0 auto;
	text-align: center;

	@media (max-width: $breakpoint-md) {
		font-size: 16px;
	}

	@media (max-width: $breakpoint-sm) {
		font-size: 14px;
	}
}
</style>
